module.exports = __webpack_public_path__ + "img/ring_r_c_0_null@3x.4f399853.png";